import React, { useMemo } from 'react';
import uuidv4 from '../../utils/uuidv4';
/**
 * Bronson ErrorMessage component.
 *
 * @see https://bronson.vwfs.io/default/components/detail/bronson-error-message.html
 */
export function ErrorMessage({ id, children, testId, ...otherProps }) {
    /**
     * Generate unique id, if prop `id` is not provided to improve accessibility.
     */
    const errorMessageId = useMemo(() => id ?? uuidv4(), [id]);
    return (React.createElement("p", { className: "c-error-message", id: `error-${errorMessageId}`, "data-testid": testId, ...otherProps }, children));
}
